import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { safeDeepGetWithType } from 'iotera-base/json';
import { TextInput } from '../../../lib/components/textInput';
import { setDevicePayload, setDeviceEmpty } from "../../../testActions";
import { store } from "../../../testStore";
import { withRouter } from 'react-router-dom';
import { S, domainIsTenant as dit } from '../../../routes/routes';
import Result from 'iotera-base/result';

import { SubViewHeaderStep } from '../../../lib/components/subHeader';
import { Button } from '@material-ui/core';
import { actions as notificationActions } from '../../../redux/ducks/notification'
import { actions as modalActions } from '../../../redux/ducks/modal'
import { buildWBoundActions, buildWSelector } from '../../../redux/ducks'
import { isEmpty } from 'iotera-base/object';
import { IoteraForm } from '../../../lib/components/form';
import { callWSingleRequestCall, storeDeviceConfig, addDeviceConfig, selectCategory, goToURLActivation } from '../function';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../../lib/components/callbackGlobal';

const CHECK_TAG = 'CHECK_TAG';
const DUMMY = 'DUMMY'
const MQTT = 'MQTT'
const TASMOTA_SONOFF_BASIC = 'TASMOTA_SONOFF_BASIC'
const RASPY = 'rasp-pi'
const ADD_DUMMY = "ADD_DUMMY"
const ADD_MQTT = "ADD_MQTT"
const ADD_TASMOTA = "ADD_TASMOTA"
const WKEY = 'DEVICE_ADD';
const wBoundActions = buildWBoundActions(WKEY);
const wSelector = buildWSelector(WKEY)

const onError = (errors) => console.log("Ada", errors.length, "error yang harus diperbaiki");

const schema = {
  type: "object",
  required: ["serial_number", "name"],
  properties: {
    serial_number: { type: "string" },
    name: { type: "string", maxLength: 32 },
  }
};

const uiSchema = {
  serial_number: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="serial_number"
          type="text"
          label="Nomor Serial"
          placeholder="AAAA-BBBB-1111-2222"
          textTooltip="Masukkan nomor serial yang tertera pada device atau bungkusannya"
          className="custom"
          value={props.value}
          onError={onError}
          required={props.required}
          onChange={event => props.onChange(event.target.value)} />
      )
    },
    "ui:options": {
      label: false
    }
  },
  name: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="name"
          type="text"
          label="Name"
          placeholder="Device M2M"
          textTooltip="Masukkan nama untuk mengenali device ini"
          value={props.value}
          onError={onError}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
        />
      )
    },
    "ui:options": {
      label: false
    }
  }
};

class Example extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: [],
      formData: {},
      values: '',
      loading: false,
      prevPath: '',
      isTag: false
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTag = this.handleTag.bind(this);
    this.onFormChange = this.onFormChange.bind(this);
  }

  componentDidMount() {
    const _this = this
    const _props = _this.props
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall(
      {
        wparam: { ...domainIsTenant, path: "/service/web/tag/category/exists" },
        wcallback: {
          started: function (id) {
            // TODO Loading
          },
          finished: function (id, result) {
            // TODO Loading
          }
        }
      }
    );
    _props.wSetConfig({
      single_config: {
        [ADD_DUMMY]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/device/dum/node/add"
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                let action = setDeviceEmpty();
                store.dispatch(action)
                _props.history.push('..' + S + '_device_list_')
                _props.showSingleNotification({ message: "Sukses", level: 'success' });
              } else {
                _props.showSingleNotification({ message: "Gagal", level: 'error' });
              }
              _this.setState({
                loading: false
              })
            }
          }
        },
        [ADD_MQTT]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/device/mqtt/node/add"
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                let action = setDeviceEmpty();
                store.dispatch(action)
                _props.history.push('..' + S + '_device_list_')
                _props.showSingleNotification({ message: "Sukses", level: 'success' });
              } else {
                _props.showSingleNotification({ message: "Gagal", level: 'error' });
              }
              _this.setState({
                loading: false
              })
            }
          }
        },
        [ADD_TASMOTA]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/device/tasmota/node/add"
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                let action = setDeviceEmpty();
                store.dispatch(action)
                _props.history.push('..' + S + '_device_list_')
                _props.showSingleNotification({ message: "Sukses", level: 'success' });
              } else {
                _props.showSingleNotification({ message: "Gagal", level: 'error' });
              }
              _this.setState({
                loading: false
              })
            }
          }
        },
      }
    });
  }

  componentWillUnmount() {
    // callback global
    unsetCallbackGlobal(this.props)
  }

  componentWillReceiveProps(nextProps) {
    const _this = this
    const _props = _this.props
    if (nextProps.location !== _props.location) {
      _this.setState({ prevPath: _props.location })
    }
  }

  handleSubmit(event) {
    const _this = this
    const _props = _this.props
    const config = '{}'
    let dataToShow = event.formData;
    let action = setDevicePayload(dataToShow);
    _this.setState({
      formData: dataToShow
    })
    store.dispatch(action)
    let type = dataToShow['type'];
    let storeValue = store.getState()
    let dataToSubmit = { ...storeValue.device }
    if (type === DUMMY) {
      return callWSingleRequestCall({ ..._props }, ADD_DUMMY, dataToSubmit)
    }
    else if (type === MQTT) {
      return callWSingleRequestCall({ ..._props }, ADD_MQTT, dataToSubmit)
    }
    else if (type === TASMOTA_SONOFF_BASIC) {
      return callWSingleRequestCall({ ..._props }, ADD_TASMOTA, dataToSubmit)
    }
    else if (type === RASPY) {
      dataToSubmit = addDeviceConfig(dataToSubmit, config)
      storeDeviceConfig(dataToSubmit)
      return _props.history.push('.' + S + 'sensors')
    }
    else {
      let category = dataToSubmit['category'];
      let selectedCategory = selectCategory(category)
      return goToURLActivation({ ..._props }, selectedCategory) // function for history.push to one of page activation
    }
  }

  onFormChange(event) {
    let dataToSubmit = event.formData;
    let action = setDevicePayload(dataToSubmit);
    store.dispatch(action)
    this.setState({
      formData: dataToSubmit
    })
  }

  handleTag() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    let { formData: dataToSubmit } = _state;
    if (isEmpty(dataToSubmit)) {
      let storeValue = store.getState();
      dataToSubmit = storeValue;
      if (!isEmpty(dataToSubmit)) {
        if ('device' in dataToSubmit) {
          if (!isEmpty(dataToSubmit.device)) {
            dataToSubmit = dataToSubmit.device;
          }
        }
      }
    }
    if (isEmpty(dataToSubmit)) {
      _props.showSingleNotification({ message: 'Nomor serial tidak boleh kosong', level: 'error' });
    } else {
      const serial = dataToSubmit.serial_number;
      const name = dataToSubmit.name;
      if (serial === undefined) {
        _props.showSingleNotification({ message: 'Nomor serial tidak boleh kosong', level: 'error' });
      } else if (name === undefined) {
        _props.showSingleNotification({ message: 'Nama tidak boleh kosong', level: 'error' });
      } else if (serial !== undefined && name !== undefined) {
        _this.goTo('.' + S + 'tag')
      }
    }
  }

  goTo(link) {
    this.props.history.push(link)
  }

  goBack() {
    this.props.history.push('.' + S + 'category')
  };

  render() {
    const _this = this
    const _props = _this.props
    let haveTag = safeDeepGetWithType(_props, ['haveTag'], false);
    let storeValue = store.getState();
    let dataToShow = storeValue;
    if (isEmpty(dataToShow)) {
      _this.goBack();
    } else {
      if ('device' in dataToShow) {
        if (isEmpty(dataToShow.device)) {
          _this.goBack();
        } else {
          dataToShow = dataToShow.device;
        }
      } else {
        _this.goBack();
      }
    }
    let type = safeDeepGetWithType(dataToShow, ['type'], DUMMY);
    return (
      <div className="view">
        {type === DUMMY || type === MQTT || type == TASMOTA_SONOFF_BASIC ?
          <SubViewHeaderStep title='Tambah Perangkat' subTitle='Permohonan tambah perangkat baru'
            steps={['Kategori', 'Informasi']} activeStep={1} /> :
          type === RASPY ?
            <SubViewHeaderStep title='Tambah Perangkat' subTitle='Permohonan tambah perangkat baru'
              steps={['Kategori', 'Informasi', 'Konfigurasi', 'Aktivasi']} activeStep={1} /> :
            <SubViewHeaderStep title='Tambah Perangkat' subTitle='Permohonan tambah perangkat baru'
              steps={['Kategori', 'Informasi', 'Aktivasi']} activeStep={1} />
        }
        <div className="io-container mt-12">
          <IoteraForm
            schema={schema}
            uiSchema={uiSchema}
            onChange={_this.onFormChange}
            onSubmit={_this.handleSubmit}
            formData={dataToShow}
          >
            <div className="button-right" style={{ marginTop: 10 }}>
              <Button variant="outlined" size="large" style={{ minWidth: '0%' }} onClick={_props.history.goBack} >Kembali</Button>
              {haveTag ?
                <Button variant="outlined" size="large" color="primary"
                  style={{ marginLeft: 10, minWidth: '0%' }} onClick={_this.handleTag} >Penanda</Button> : null
              }
              {type === DUMMY || type === MQTT || type === TASMOTA_SONOFF_BASIC ?
                <Button variant="contained" size="large" color="primary" type="submit"
                  style={{ marginLeft: 10, minWidth: '0%' }}>Simpan</Button> :
                <Button variant="contained" size="large" color="primary" type="submit"
                  style={{ marginLeft: 10, minWidth: '0%' }}>Berikutnya</Button>
              }
            </div>
          </IoteraForm>
        </div>
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    haveTag: wSelector.getSoleInitMappedRPayload(state, 'value')
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch),
    ...bindActionCreators(modalActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Example));